import Navigator from 'app';
import EventModel from './event_model';
const EventCollection = Backbone.Collection.extend({
  model: EventModel,
  initialize: function (date) {
    this.url = Navigator.config.api_base + 'billevents/summary/' + date;
  }
});
const API = {
  getEventsForDate: function (date) {
    var d = $.Deferred();
    var events = new EventCollection(date);
    events.fetch({
      dataType: "json",
      success: function (data) {
        d.resolve(data);
      }
    });
    return d.promise();
  }
};
Navigator.reqres.setHandler("event:daily", function (date) {
  return API.getEventsForDate(date);
});
export { EventCollection as default };